import { render } from "./about-feedback.vue?vue&type=template&id=3da36f4b"
import script from "./about-feedback.vue?vue&type=script&lang=js"
export * from "./about-feedback.vue?vue&type=script&lang=js"

import "./about-feedback.vue?vue&type=style&index=0&id=3da36f4b&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__